import requestAction from '../../utils/requestAction'

export const fetchProductMeasurementType = (productMeasurementTypeId: string) =>
  requestAction('PRODUCTMEASUREMENTTYPE_DETAIL')(`productMeasurementTypes/${productMeasurementTypeId}`, 'GET')
